// Resolves telemetry configuration from Vite env vars, with hardcoded defaults so the
// app works out of the box and can be overridden later without code edits.
//
// `import.meta.env.VITE_*` must be referenced directly (not via an intermediate `env`
// object) so Vite can statically replace them at build time — see the comment in
// Ui/src/AppConfig.tsx for the same rule.

export interface TelemetryConfig {
  token: string;
  host: string;
  enabled: boolean;
}

export function getTelemetryConfig(): TelemetryConfig {
  return {
    token:
      import.meta.env.VITE_POSTHOG_KEY ??
      "phc_oKvJ4tXvUoB8YR9UBoTwqmkEK5YxJbJcchcUb9hBoWAk",
    host: import.meta.env.VITE_POSTHOG_HOST ?? "https://us.i.posthog.com",
    enabled: import.meta.env.VITE_TELEMETRY_ENABLED !== "false",
  };
}
